import React from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./FoodCourtCategories.module.css";
import FoodCourtCategoriesSkeleton from "./skeleton/FoodCourtCategoriesSkeleton";
import playClickSpecial from "utils/playClickSpecial";
import phoneBlack from "assets/images/icon-phone-black.svg";
import placeholder1000x625 from "assets/placeholder/1000x625.png";

function FoodCourtCategories(props) {
  const { loading, categories, titleCategories } = props;
  const location = useLocation();
  const pathname = location.pathname;

  if (!categories || loading) {
    return <FoodCourtCategoriesSkeleton />;
  }

  return (
    <div className={styles.item_categories}>
      <h2 className={styles.title_categories}>{titleCategories}</h2>
      <div className={styles.wrapp_item_content}>
        <h4 className={styles.title}>{categories.title}</h4>
        <div className={styles.phone_number}>
          <img src={phoneBlack} className={styles.phone_image} alt="" />
          {categories.phone}
        </div>
        <div className={styles.item_image}>
          {categories.id && categories.code ? (
            <Link
              to={{
                pathname: `${pathname}/${categories.id}`,
                search: `?code=${categories.code}`,
              }}
              onClick={playClickSpecial}
            >
              <img
                src={categories.thumb || placeholder1000x625}
                alt={categories.title}
              />
            </Link>
          ) : (
            <img
              src={categories.thumb || placeholder1000x625}
              alt={categories.title}
            />
          )}
        </div>
      </div>
    </div>
  );
}
export default FoodCourtCategories;
